import { createSelector } from 'reselect';

const baseSubscriptionsSelector = (state: any) => state?.subscriptions;

export const subscriptionSelector = (state: any) => state?.subscriptions;

export const selectedPlanSelector = createSelector(
  baseSubscriptionsSelector,
  (subscriptions) => subscriptions?.selectedPlan
);

export const plansSelector = createSelector(baseSubscriptionsSelector, (subscriptions) => subscriptions?.plans || []);

export const cancelPlanSelector = createSelector(
  baseSubscriptionsSelector,
  (subscriptions) => subscriptions?.cancelPlan || null
);

export const paymentSelector = createSelector(
  baseSubscriptionsSelector,
  (subscriptions) => subscriptions?.payment || null
);

export const activeProductSelector = createSelector(
  baseSubscriptionsSelector,
  (subscriptions) => subscriptions?.activeProduct || null
);

export const currentUpsalePlanSelector = createSelector(
  baseSubscriptionsSelector,
  (subscriptions) => subscriptions?.currentUpsalePlan || null
);
